// extracted by mini-css-extract-plugin
var _1 = "iuvEY";
export { _1 as "header" }
